import { render, staticRenderFns } from "./SubjectPanel.vue?vue&type=template&id=4bb8430e&scoped=true&"
import script from "./SubjectPanel.vue?vue&type=script&lang=js&"
export * from "./SubjectPanel.vue?vue&type=script&lang=js&"
import style0 from "./SubjectPanel.vue?vue&type=style&index=0&id=4bb8430e&prod&lang=less&scoped=true&"
import style1 from "./SubjectPanel.vue?vue&type=style&index=1&id=4bb8430e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb8430e",
  null
  
)

export default component.exports